/* eslint-disable react-hooks/exhaustive-deps */
import {Typography} from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useUtilInformation} from 'components/hooks';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {i18n2} from '../../../features/i18n/i18n';
import {DELETE_ALL_COLLABORATOR, SET_ALL_COLLABORATOR} from '../types/types';
import {getSectorsFromCourse, useGetAssistants} from '../hooks/index';
import CustomList from './CustomList';
import {AssistantGrid, CollaboratorAssistantGrid} from './index';
import ButtonsContainer from './ButtonsContainer';
import useLoadCollaboratorPUT from '../hooks/useLoadCollaboratorPUT';
import {useLoadProfCollaboratorWithFilters} from 'features/profCollaborator/hooks/useLoadProfCollaborator';
import {AddWith2ParamsOptions} from 'components/grid-dx/types';

interface InstanceIdsProps {
  iD_Course: number;
  iD_Instance: number;
}

interface FilterListProps {
  ids: InstanceIdsProps;
  role: string;
  courseType: string;
}

const FilterList = ({ids, role, courseType}: FilterListProps) => {
  const {iD_Course, iD_Instance}: InstanceIdsProps = ids;
  const isSpacCourse = courseType === 'SAC';
  const classes = useStyles();
  const [elements, setElements] = useState<any | null>([]);
  const [redirect, setRedirect] = useState<boolean>(false);
  const {token} = useUtilInformation();
  const dispatch = useDispatch();
  const assistants = useGetAssistants();

  const loadCollaboratorWithFilters = useLoadCollaboratorPUT(
    iD_Instance,
    iD_Course,
    true,
  );
  const loadProfCollaboratorWithFilters = useLoadProfCollaboratorWithFilters(
    'AddInstance',
    iD_Instance,
    iD_Course,
  );

  const loadProfCollaboratorWithFiltersAddAll =
    useLoadProfCollaboratorWithFilters('selectAll');

  const selectAll = () => {
    const load = isSpacCourse
      ? loadProfCollaboratorWithFilters
      : loadCollaboratorWithFilters;
    load.load().then((data: any) => {
      if (data?.data?.length > 0) {
        dispatch({type: SET_ALL_COLLABORATOR, payload: data.data});
      } else if (data?.length > 0) {
        dispatch({type: SET_ALL_COLLABORATOR, payload: data});
      }
    });
  };

  // Esta función trae todos los colaboradores, no solo los de la grilla.
  // Así es como funcionaba previamente el botón "Seleccionar todos" cuando se trataba de un curso SAC.
  // Se mantiene esta funcionalidad pero no visible en la UI.
  const addAllBackendSAC = () => {
    const load = isSpacCourse
      ? loadProfCollaboratorWithFiltersAddAll
      : loadCollaboratorWithFilters;
    load.load().then((data: any) => {
      if (data?.data?.length > 0) {
        dispatch({type: SET_ALL_COLLABORATOR, payload: data.data});
      } else if (data?.length > 0) {
        dispatch({type: SET_ALL_COLLABORATOR, payload: data});
      }
    });
  };

  const deselectAll = () => {
    dispatch({type: DELETE_ALL_COLLABORATOR, payload: true});
  };

  useEffect(() => {
    return () => {
      dispatch({type: DELETE_ALL_COLLABORATOR, payload: true});
    };
  }, [redirect]);

  useEffect(() => {
    if (!isSpacCourse) {
      getSectorsFromCourse(iD_Course, role, token)
        .then((data: any) => {
          setElements(data);
        })
        .catch((error: any) => console.log(error));
    }
  }, []);

  if (redirect) return <Redirect to="/Management" />;

  const jsonVariables = {
    id_instance: iD_Instance,
    id_course: iD_Course,
  };

  const addWith2ParamsOptions: AddWith2ParamsOptions = {
    AddedOne: assistants,
    AddedTwo: jsonVariables,
    AddedThree: {},
  };

  return (
    //ACA SE UTILIZA FLEXBOX. root es el padre, luego esta la grilla izquierda que trae los sectores, a su derecha una columna con sus las 2 grillas.
    <div className={classes.root}>
      {!isSpacCourse ? (
        <Grid style={{width: '50vh', paddingBottom: '1vh'}}>
          <div style={{paddingLeft: '10px'}}>
            {<CustomList elements={elements} />}
          </div>
        </Grid>
      ) : null}
      <Grid className={classes.right} container spacing={5}>
        <Grid className={classes.children}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Typography variant="h6" style={{paddingLeft: '10px'}}>
              {i18n2._('Agregar Asistentes')}
            </Typography>
            <ButtonsContainer
              onSelectAll={selectAll}
              onAddAllSAC={addAllBackendSAC}
              onDeselectAll={deselectAll}
              onCancel={() => setRedirect(true)}
              redirect={redirect}
              setRedirect={setRedirect}
              addWith2ParamsOptions={addWith2ParamsOptions}
            />
          </div>

          <AssistantGrid
            useSpac={isSpacCourse}
            role={role}
            iD_Instance={iD_Instance}
            iD_Course={iD_Course}
          />
        </Grid>
        <Grid className={classes.children} container>
          <Typography variant="h6" style={{paddingLeft: '10px'}}>
            {i18n2._('Asistentes seleccionados')}
          </Typography>
          <CollaboratorAssistantGrid
            useSpac={isSpacCourse}
            iD_Instance={iD_Instance}
            iD_Course={iD_Course}
            token={token}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      height: '100%',
      width: '100%',
      flexDirection: 'row',
      overflowX: 'hidden',
      overflowY: 'hidden',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      alignContent: 'stretch',
      flexBasis: 'auto', //se define el tamaño de un item en terminos del espacio que deja como espacio disponible
      alignSelf: 'auto',
    },
    right: {
      margin: 'auto',
      marginTop: 7,
      width: '90%',
      flexDirection: 'column',
    },

    children: {
      margin: 'auto',
      height: 'auto',
      width: 'auto',
    },
    button: {
      margin: 'auto',
      height: 'auto',
      width: 'auto',
      display: 'grid',
      gridAutoFlow: 'column',
      gridColumnGap: 10,
      paddingBottom: 10,
    },
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(1),
    },

    btnCancel: {
      color: '#8B0000',
      borderColor: '#8B0000',
      '&:hover': {
        backgroundColor: 'rgba(139, 0, 0, 0.1)',
        borderColor: '#600000',
      },
    },
    btnSelect: {
      fontWeight: 600,
      color: '#1C4257',
      borderColor: '#1C4257',
      backgroundColor: 'rgba(21, 101, 192, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(21, 101, 192, 0.25)',
        borderColor: '#0D47A1',
      },
      marginRight: theme.spacing(1),
    },
    btnDeselect: {
      fontWeight: 600,
      color: '#8B0000',
      borderColor: '#8B0000',
      backgroundColor: 'rgba(139, 0, 0, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(139, 0, 0, 0.25)',
        borderColor: '#600000',
      },
    },
    divider: {
      margin: `0 ${theme.spacing(1.5)}px`,
      height: theme.spacing(4),
    },
  }),
);

export default FilterList;
